export default function () {
  const cookieGet = require('./cookies/cookie.get');
  const storage = cookieGet('cookieinfo');
  const current = storage !== null ? storage : false;
  const ignore = 'homescreen-ignore';
  const exeptions = ['CriOS', 'EdgiOS', 'EdgA', 'FxiOS', 'Firefox'];
  let matchExeptions = false;

  // If no iOS and not on homepage and no localstorage: skip all
  if ( !app.helper.browser().mobile || !app.test.isTouchDevice || !app.test.isLocalStorageSupported || (typeof hideWebAppTrigger !== 'undefined' && hideWebAppTrigger) ) {
    return;
  }

  // When ignore; stop here
  if ( app.helper.localStorage.getItem(ignore) !== null ) {
    return;
  }

  // If unknown or not native browser; skip
  for ( let i = 0; i < exeptions.length; i++ ) {
    const ua = navigator.userAgent;
    const regex = new RegExp(exeptions[i], 'gi');

    if ( ua.match(regex) ) {
      matchExeptions = true;
    }
  }

  if ( matchExeptions ) {
    return;
  }

  // Check, show if match
  if ( window.location.pathname === '/dashboard/' && current !== false ) {
    _triggerPopup();
    _ignoreTrigger();
  }

  /**
   * Return device
   *
   * @returns {*}
   * @private
   */
  function _device() {
    let device = false;

    if ( navigator.userAgent.match(/iPad/g ) ) {
      device = 'ipad';
    } else if ( navigator.userAgent.match(/iPhone|iPod/g ) && !navigator.userAgent.match(/CriOS/g ) ) {
      device = 'iphone';
    } else if ( app.helper.browser().mobile === 'android' && app.helper.giveScreenWidth < 38 ) {
      device = 'android-phone';
    }

    return device;
  }

  /**
   * Ignore this message; save to localstorage and don't ask again
   * @private
   */
  function _ignoreTrigger() {
    document.querySelector('.js-close-homescreen-trigger').addEventListener('click', function(e) {
      document.querySelector('.trigger-homescreen').remove();

      app.helper.localStorage.setItem(ignore, true);

      e.preventDefault();
    });
  }

  /**
   * Trigger popup
   *
   * @private
   */
  function _triggerPopup() {
    let device = _device();
    let stepsHTML = '';

    if ( !device ) {
      return;
    }

    if ( device === 'android-phone' ) {
      stepsHTML = `
			Tik hierboven op &lsquo;<img src="/images/icons/homescreen/android-trigger.png" class="trigger-homescreen__icon" alt="Gebruik deze trigger">&rsquo; en kies dan 
			&lsquo;Toevoegen aan startscherm&rsquo;
		`;
    } else {
      stepsHTML = `
			Tik op &lsquo;<img src="/images/icons/homescreen/ios10-trigger.png" class="trigger-homescreen__icon" alt="Gebruik deze trigger">&rsquo; en kies dan 
			&lsquo;<img src="/images/icons/homescreen/ios10-add-to-homescreen.png" class="trigger-homescreen__icon" alt="Voeg toe aan beginscherm"> Zet op beginscherm&rsquo;
		`
    }

    let template = `
		<div class="trigger-homescreen trigger-homescreen--${device}">
			<h3 class="trigger-homescreen__title">Zet WeAreGolf tussen je apps!</h3>
			<p class="trigger-homescreen__desc">Open de website eenvoudiger en sneller.<br>
				${stepsHTML}
			</p>
			<a href="#close" class="trigger-homescreen__close js-close-homescreen-trigger">
			  <svg class="trigger-homescreen__close__img" width="15" height="15"><use xlink:href="/build/web/svg/symbol/svg/sprite.symbol.svg#icon-false"></use></svg>
			</a>
		</div>
	`;

    document.body.innerHTML += template;
  }
};
